module.exports = __webpack_public_path__ + "static/media/OrderConfirmed.8f8ecb95.svg";